

<div class="curation">

  <div *ngIf="isWaitingForManualCurationAvailable">
    <div class="main-title">
      <span class="icon icon__refresh-therapy"></span>
      <section class="section-title">
        <span class="first-text-line">Waiting for therapy match to be completed</span>
      </section>
    </div>
  </div>

  <div *ngIf="!isWaitingForManualCurationAvailable && IsMDA">
    <div class="main-title no-overflow">
      <span class="icon icon__warning_background warning-icon"></span>
      <section class="section-title with-icon">
        <div class="warning-title first-text-line">{{selectedAberrationKeys.length}} selected aberrations</div>
      </section>
      <div class="simple-text-line text-line">Would you like to proceed with all current available aberrations or request manual interpretation for</div>
      <div class="simple-text-line text-line">selected aberrations*?</div>
      <div class="simple-text-line last-text-line">* Manual interpretation may incur additional costs</div>
    </div>

    <div class="main-buttons-container">
      <ng-container *ngFor="let inputButton of inputButtonArgs;let i = index">
      <gen-button
              class="single-button"
              [fullSize]="true"
              [type]="i === 0 ? 'primary' :'secondary'"
              [disabled]="isUserCanPressManualinterpretationButton(inputButton.key)||(i === 0 && selectedAberrationKeys.length<1)"
              [text]="inputButton.value"
              (click)="performWorkflowStep(inputButton.args)"
      ></gen-button>
        <span>&nbsp;</span>
      </ng-container>
    </div>
  </div>


  <div *ngIf="!isWaitingForManualCurationAvailable && !IsMDA">
    <div class="main-title no-overflow">
      <span class="icon icon__warning_background warning-icon"></span>
      <section class="section-title with-icon">
        <div class="warning-title first-text-line">{{totalUncurated$|async}} selected aberrations were returned uncharacterized</div>
      </section>
      <div class="simple-text-line text-line">Would you like to proceed with the current available aberrations or request manual curation for</div>
      <div class="simple-text-line text-line">uncharacterized aberrations*?</div>
      <div class="simple-text-line last-text-line">* Manual curation may incur additional costs</div>
    </div>
    <div class="main-buttons-container">
      <gen-button
              *ngFor="let inputButton of inputButtonArgs;let i = index"
              class="single-button"
              [fullSize]="true"
              [disabled]="isUserCanPressManualCurationButton(inputButton.key)"
              [type]="i === 0 ? 'primary' :'secondary'"
              [text]="inputButton.value"
              (click)="performWorkflowStep(inputButton.args)"
      ></gen-button>
    </div>
  </div>
</div>